export function galleryImageUrl(galleryUUID: string, imageUUID: string, siteUUID: string, contentCdnUrl: string) {
  return `${contentCdnUrl}/${siteUUID}/media/${galleryUUID}/s_${imageUUID}.jpg`;
}
